import * as React from "react";

interface LogoProps {
  textColor: string;
  className?: string;
}

export const EqualHousingLenderLogo: React.FC<LogoProps> = ({ textColor, className = "h-4.5 w-auto shrink-0" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 136 29"
      className={className}
      aria-label="Equal Housing Lender Logo"
    >
      <title>Equal Housing Lender</title>
      <g fill={textColor}>
        <path d="M19.194,0 L37.959,11.031 L37.959,14.870 L34.965,14.870 L34.965,28.443 L2.940,28.443 L2.940,14.870 L0,14.870 L0,10.923 L19.194,0 Z M19.192,4.112 L6.842,11.359 L6.842,24.985 L31.275,24.985 L31.275,11.359 L19.192,4.112 Z M25.401,18.189 L25.401,21.542 L12.623,21.542 L12.623,18.189 L25.401,18.189 Z M25.401,13.195 L25.401,16.548 L12.623,16.548 L12.623,13.195 L25.401,13.195 Z"></path>
        <text
          x="44"
          y="12"
          fill={textColor}
          fontFamily="inherit"
          fontSize="11"
          fontWeight="700"
          textLength="92"
          lengthAdjust="spacing"
        >
          EQUAL HOUSING
        </text>
        <text
          x="44"
          y="26"
          fill={textColor}
          fontFamily="inherit"
          fontSize="16"
          fontWeight="900"
          textLength="92"
          lengthAdjust="spacingAndGlyphs"
        >
          LENDER
        </text>
      </g>
    </svg>
  );
};

export const EqualHousingOpportunityLogo: React.FC<LogoProps> = ({
  textColor,
  className = "h-4.5 w-auto shrink-0",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 140 29"
      className={className}
      aria-label="Equal Housing Opportunity Logo"
    >
      <title>Equal Housing Opportunity</title>
      <g fill={textColor}>
        <path d="M19.194,0 L37.959,11.031 L37.959,14.870 L34.965,14.870 L34.965,28.443 L2.940,28.443 L2.940,14.870 L0,14.870 L0,10.923 L19.194,0 Z M19.192,4.112 L6.842,11.359 L6.842,24.985 L31.275,24.985 L31.275,11.359 L19.192,4.112 Z M25.401,18.189 L25.401,21.542 L12.623,21.542 L12.623,18.189 L25.401,18.189 Z M25.401,13.195 L25.401,16.548 L12.623,16.548 L12.623,13.195 L25.401,13.195 Z"></path>
        <text
          x="44"
          y="12"
          fill={textColor}
          fontFamily="inherit"
          fontSize="11"
          fontWeight="700"
          textLength="92"
          lengthAdjust="spacing"
        >
          EQUAL HOUSING
        </text>
        <text
          x="44"
          y="26"
          fill={textColor}
          fontFamily="inherit"
          fontSize="16"
          fontWeight="700"
          textLength="92"
          lengthAdjust="spacingAndGlyphs"
        >
          OPPORTUNITY
        </text>
      </g>
    </svg>
  );
};
